import { render } from "./org.html?vue&type=template&id=c2d6c272&scoped=true&ts=true"
import script from "./org.ts?vue&type=script&lang=ts"
export * from "./org.ts?vue&type=script&lang=ts"

import "./org.scss?vue&type=style&index=0&id=c2d6c272&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2d6c272"]])

export default __exports__